import axios from '@/axios/'

const actions = {
  // 出品情報取得
  getResaleTargetList(_, param) {
    return axios.post('/GetTktResaleTargetList/1.0/', param)
  },
  // 入金先情報取得
  getTktResalePaymentInfo() {
    return axios.get('/GetTktResalePaymentInfo/1.0/')
  },
  // 出品情報削除
  delTktResaleInfo(_, param) {
    return axios.post('/DelTktResaleInfo/1.0/', param)
  },
  // 出品手数料取得
  getPutUpTicketCharge(_, param){
    return axios.post('/GetPutUpTicketCharge/1.0/', param)
  },
  // 出品情報登録
  SetTktResaleInfo(_, param){
    return axios.post('/SetTktResaleInfo/1.0/', param)
  },
  // 出品情報変更
  UpdTktResaleInfo(_, param){
    return axios.post('/UpdTktResaleInfo/1.0/', param)
  }
}

const state = {
  getKbn: undefined,
  eventCode: undefined,
  tickets: undefined
}

const mutations = {
  setGetKbn(state, getKbn){
    state.getKbn = getKbn
  },
  setEventCode(state, eventCode){
    state.eventCode = eventCode
  },
  setTickets(state, tickets){
    state.tickets = tickets
  },
  clear(state){
    state.getKbn = undefined,
    state.eventCode = undefined,
    state.tickets = undefined
  }
}

export default {
  namespaced: true,
  actions,
  state,
  mutations
}
